var _svg;
import React, { useEffect, useState } from 'react';
import colors from "../../theme/colors";
import { Box } from '@mui/material';

// Types

import Typography from "../Typography";
import HtmlRenderer from "../HtmlRenderer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = ({
  isChecked = false,
  onChange,
  title,
  isRevert = false
}) => {
  const [isCheck, setIsCheck] = useState(true);
  useEffect(() => {
    setIsCheck(isChecked);
  }, [isChecked]);
  const Icon = _svg || (_svg = /*#__PURE__*/_jsx("svg", {
    width: "14",
    height: "10",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M1 5L5 9L13 1",
      stroke: "#0169B2",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexDirection: isRevert ? 'row-reverse' : 'unset',
      width: '100%'
    },
    children: [title && /*#__PURE__*/_jsx(Typography, {
      variant: 'p5',
      color: colors.otherColor.english,
      onClick: () => {
        setIsCheck(!isCheck);
        onChange(!isCheck);
      },
      sx: {
        width: '100%',
        cursor: 'pointer',
        fontSize: "16px",
        lineHeight: "22px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        overflow: "hidden",
        display: "block",
        textOverflow: "ellipsis",
        marginRight: "4px"
      },
      children: /*#__PURE__*/_jsx(HtmlRenderer, {
        component: "div",
        value: title
      })
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: "flex",
        width: 24,
        height: 24,
        minWidth: 24,
        minHeight: 24,
        justifyContent: 'center',
        alignItems: 'center',
        background: isCheck ? "rgba(1, 105, 178, 0.1)" : colors.neutral.neutral6,
        borderRadius: "4px",
        border: "1px solid",
        borderColor: isCheck ? colors.secondary.bandaiNamcoBlue : colors.neutral.neutral6,
        transform: "all 0.3s",
        cursor: "pointer"
      },
      onClick: () => {
        setIsCheck(!isCheck);
        onChange(!isCheck);
      },
      children: isCheck && Icon
    })]
  });
};
export default Checkbox;